export enum PaymentStatus {
  Success = 'Success',
  Failure = 'Failure'
}
